import React, {memo, useContext} from 'react';
import './OrderDetails.less';
import {CartPicker} from '../cart-picker/CartPicker';
import {CartPickerTrigger} from '../cart-picker-trigger/CartPickerTrigger';

import AboutIcon from 'new-images/about.svg';
import TimeIcon from 'new-images/time.svg';
import LocationIcon from 'new-images/location.svg';
import CommentIcon from 'new-images/comment.svg';
import TableIcon from 'new-images/table.svg';
import {CartPickerTriggerIcon} from 'elements/cart-picker-trigger-icon/CartPickerTriggerIcon';
import {ListItem} from "elements/list-item/ListItem.tsx";
import {List} from "elements/list/List.tsx";
import {OrderingTypes} from "new-constants/common.constants";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {Cutlery} from "compositions/cutlery/Cutlery";


export const OrderDetails = memo(
	({
		 pickupLocation,
		 isShowTableNumber,
		 tableNumber,
		 onTableNumberClick,
		 isShowPickupTime,
		 orderingType,
		 pickupTime,
		 isShowAddress,
		 pickupAddress,
		 isShowComment,
		 comment,
		 isShowCutlery,
		 restaurantDeliveryLabel,
		 cutlery,
		 onTimeClick,
		 onAddressClick,
		 onCommentClick,
		 onCutleryIncClick,
		 onCutleryDecClick
	 }) => {

		const translations = useContext(TranslationsContext);

		return (
			<List>
				<ListItem key="pickup-location" isIncreasedBorderPadding>
					<CartPicker title={getSafeTranslation('OrderDetails.pickupLocationLabel', translations)}>
						<CartPickerTrigger
							icon={<CartPickerTriggerIcon icon={AboutIcon}/>}
							text={pickupLocation}
						/>
					</CartPicker>
				</ListItem>
				{
					isShowTableNumber && (
						<ListItem key={restaurantDeliveryLabel} onClick={onTableNumberClick} isIncreasedBorderPadding>
							<CartPicker title={getSafeTranslation('OrderDetails.' + restaurantDeliveryLabel, translations)}>
								<CartPickerTrigger
									icon={<CartPickerTriggerIcon icon={TableIcon}/>}
									text={tableNumber || getSafeTranslation('OrderDetails.' + restaurantDeliveryLabel + 'NotSelectedPickerCaption', translations)}
								/>
							</CartPicker>
						</ListItem>
					)
				}
				{
					isShowPickupTime && (
						<ListItem key="pickup-time" onClick={onTimeClick} isIncreasedBorderPadding>
							<CartPicker
								title={orderingType === OrderingTypes.delivery ? getSafeTranslation('OrderDetails.deliveryTimeLabel', translations) : getSafeTranslation('OrderDetails.pickupTimeLabel', translations)}>
								<CartPickerTrigger
									icon={<CartPickerTriggerIcon icon={TimeIcon}/>}
									text={pickupTime || getSafeTranslation('OrderDetails.pickupTimeNotSelectedPickerCaption', translations)}
								/>
							</CartPicker>
						</ListItem>
					)

				}
				{
					isShowAddress && (
						<ListItem key="delivery-address" onClick={onAddressClick} isIncreasedBorderPadding>
							<CartPicker title={getSafeTranslation('OrderDetails.deliveryAddressLabel', translations)}>
								<CartPickerTrigger
									icon={<CartPickerTriggerIcon icon={LocationIcon}/>}
									text={pickupAddress || getSafeTranslation('OrderDetails.deliveryAddressNotSelectedPickerCaption', translations)}
								/>
							</CartPicker>
						</ListItem>
					)
				}
				{
					isShowComment && (<ListItem key="comment" onClick={onCommentClick} isIncreasedBorderPadding>
						<CartPicker title={getSafeTranslation('OrderDetails.commentLabel', translations)}>
							<CartPickerTrigger icon={<CartPickerTriggerIcon icon={CommentIcon}/>}
																 text={comment || getSafeTranslation('OrderDetails.commentNotSelectedPickerCaption', translations)}/>
						</CartPicker>
					</ListItem>)
				}
				{
					isShowCutlery && (<ListItem key="cutlery" isIncreasedBorderPadding>
						<CartPicker title={getSafeTranslation('OrderDetails.cutleryLabel', translations)}>
							<Cutlery
								cutlery={typeof cutlery === 'number' ? '' + cutlery : getSafeTranslation('OrderDetails.cutleryNotSelectedPickerCaption', translations)}
								onIncClick={onCutleryIncClick}
								onDecClick={onCutleryDecClick}
							/>
						</CartPicker>
					</ListItem>)
				}

			</List>
		);
	});
